module.exports = __webpack_public_path__ + "img/WebStorm_icon.ac22bb7e.png";